import { render } from "./UnfixeableClaimProductsList.vue?vue&type=template&id=539d2dff"
import script from "./UnfixeableClaimProductsList.vue?vue&type=script&lang=js"
export * from "./UnfixeableClaimProductsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__